/* 작가 추천 링크 — 작가가 퍼뜨린 작품 링크(`/c/{workId}?ref={작가코드}`)로 들어온 이용자는 그 작가 정산을 더 쳐 준다(기획).
   상세 화면에 ?ref 로 들어오면 작품별로 30일 기억하고, 대화방을 만들 때 서버에 함께 보낸다. 정산 판단은 서버가 한다. */

const KEY = 'veluvit:ref'
const TTL = 30 * 24 * 60 * 60 * 1000

type Refs = Record<string, { code: string; at: number }>

const read = (): Refs => {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(KEY) || '{}')
    return parsed && typeof parsed === 'object' ? (parsed as Refs) : {}
  } catch {
    return {}
  }
}

/**
 * 작가 코드 모양 — 서버 서명 코드 `작가id:서명`(Django Signer, GET /creator/me/referral/)만 받는다(주소에서 온 값이라 그대로 믿지 않는다).
 * 예전 스튜디오가 만들던 임시 코드(콜론 없음)는 서버가 거절해 대화 시작이 막혔다 — 저장 · 읽기 모두에서 거른다(2026-10-13)
 */
const valid = (code: string) => /^[\w-]{1,64}:[\w-]{20,64}$/.test(code)

/** 추천 링크로 들어왔을 때 — 같은 작품은 먼저 들어온 링크를 지키지 않고 가장 최근 링크로 바꾼다 */
export function saveRef(workId: string, code: string | null) {
  if (!code || !valid(code)) return
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ ...read(), [workId]: { code, at: Date.now() } })
    )
  } catch {
    // 저장소를 못 쓰면 이번 방문 동안은 추천을 기억하지 못한다
  }
}

/** 이 작품의 유효한 추천 코드(30일) */
export function readRef(workId: string): string | undefined {
  const hit = read()[workId]
  return hit && Date.now() - hit.at < TTL && valid(hit.code)
    ? hit.code
    : undefined
}
